import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2, Save } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { useOrgAdminClient } from "../hooks/useOrgAdminClient.js";
import { useOrgAdminT } from "../i18n/context.js";
export function SettingsPage() {
    const t = useOrgAdminT();
    const client = useOrgAdminClient();
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    useEffect(() => {
        (async () => {
            try {
                const res = await client.getSettings();
                setSettings(res.data);
            }
            catch (e) {
                setError(e instanceof Error ? e.message : t("settings.failedLoad"));
            }
            finally {
                setLoading(false);
            }
        })();
    }, [client, t]);
    const handleSave = useCallback(async () => {
        if (!settings)
            return;
        setSaving(true);
        setError(null);
        setSuccess(false);
        try {
            const res = await client.updateSettings(settings);
            setSettings(res.data);
            setSuccess(true);
            setTimeout(() => setSuccess(false), 3000);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : t("settings.failedSave"));
        }
        finally {
            setSaving(false);
        }
    }, [client, settings, t]);
    if (loading) {
        return (_jsxs("div", { className: "flex items-center gap-2 py-12 text-sm text-slate-400", children: [_jsx(Loader2, { className: "h-4 w-4 animate-spin" }), " ", t("settings.loading")] }));
    }
    if (!settings) {
        return _jsx("p", { className: "py-8 text-center text-sm text-slate-400", children: t("settings.couldNotLoad") });
    }
    return (_jsxs("div", { className: "max-w-md space-y-4", children: [_jsx("h2", { className: "text-lg font-semibold", children: t("settings.title") }), error && (_jsx("div", { className: "rounded-md bg-red-50 p-3 text-sm text-red-700 dark:bg-red-900/20 dark:text-red-400", children: error })), success && (_jsx("div", { className: "rounded-md bg-green-50 p-3 text-sm text-green-700 dark:bg-green-900/20 dark:text-green-400", children: t("settings.saved") })), _jsxs("div", { children: [_jsx("label", { className: "mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300", children: t("settings.maxUsers") }), _jsx("input", { type: "number", min: 1, value: settings.maxUsers, onChange: (e) => setSettings({ ...settings, maxUsers: Number(e.target.value) || 1 }), className: "w-full rounded-md border border-slate-200 bg-transparent px-3 py-1.5 text-sm outline-none focus:border-indigo-400 dark:border-slate-700" })] }), _jsxs("div", { children: [_jsx("label", { className: "mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300", children: t("settings.tier") }), _jsxs("select", { value: settings.tier, onChange: (e) => setSettings({ ...settings, tier: e.target.value }), className: "w-full rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm dark:border-slate-700 dark:bg-slate-900", children: [_jsx("option", { value: "free", children: t("settings.tierFree") }), _jsx("option", { value: "starter", children: t("settings.tierStarter") }), _jsx("option", { value: "professional", children: t("settings.tierProfessional") }), _jsx("option", { value: "enterprise", children: t("settings.tierEnterprise") })] })] }), _jsxs("button", { type: "button", onClick: handleSave, disabled: saving, className: "inline-flex items-center gap-1.5 rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-indigo-700 disabled:opacity-50", children: [saving ? _jsx(Loader2, { className: "h-3.5 w-3.5 animate-spin" }) : _jsx(Save, { className: "h-3.5 w-3.5" }), t("settings.saveSettings")] })] }));
}
//# sourceMappingURL=SettingsPage.js.map